import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import React from 'react';
import { KeyInformationCardStyles as S } from './KeyInformationCard.styles';
const KeyInformationCard = ({ accessType, cta, date, eventPricing, location, title, translations, }) => {
    return (React.createElement(S.Container, null,
        title && React.createElement(S.Title, null, title),
        React.createElement(S.Content, null,
            accessType && (React.createElement(S.Information, null,
                React.createElement(S.InformationIcon, null, getSvgFromSystem(SystemIcon.User)),
                React.createElement("span", null, accessType))),
            date && (React.createElement(S.Information, null,
                React.createElement(S.InformationIcon, null, getSvgFromSystem(SystemIcon.Calendar)),
                React.createElement("span", null, date))),
            location && (React.createElement(S.Information, null,
                React.createElement(S.InformationIcon, null, getSvgFromSystem(SystemIcon.CardPin)),
                React.createElement("span", null, location))),
            React.createElement(S.Hr, null),
            eventPricing &&
                eventPricing.map((price, index) => (React.createElement(S.Information, { key: `information-${index}` },
                    React.createElement(S.InformationIcon, null, price.icon == 'online'
                        ? getSvgFromSystem(SystemIcon.Online)
                        : getSvgFromSystem(SystemIcon.InPerson)),
                    React.createElement("span", null,
                        price.attendanceType,
                        React.createElement("br", null),
                        price.pricing ?? translations['translations.event.keyInformation.freePricing'])))),
            cta && (React.createElement(S.Cta, { href: cta.url, target: cta.target ?? '_self', id: cta.id, styleType: "solid", buttonSize: "small", title: cta.text ?? translations['translations.global.btn.bookNow'] })))));
};
export default KeyInformationCard;
